module.exports = __webpack_public_path__ + "img/renzheng.634881dc.svg";